import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { Trophy, Medal, Award } from "lucide-react";

const ICON = (i) => i === 0 ? <Trophy className="w-5 h-5 text-amber-500" /> : i === 1 ? <Medal className="w-5 h-5 text-slate-400" /> : i === 2 ? <Award className="w-5 h-5 text-orange-500" /> : <span className="font-mono text-slate-400 text-sm">{i + 1}</span>;

function tierFor(points) {
  if (points >= 500) return { label: "Especialista", color: "bg-amber-100 text-amber-700" };
  if (points >= 200) return { label: "Operador Certificado", color: "bg-emerald-100 text-emerald-700" };
  if (points >= 50) return { label: "Iniciante", color: "bg-sky-100 text-sky-700" };
  return { label: "Recém-chegado", color: "bg-slate-100 text-slate-600" };
}

export default function Ranking() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/ranking").then((r) => setItems(r.data)); }, []);
  return (
    <div className="space-y-8" data-testid="ranking-page">
      <header>
        <div className="eyebrow">Gamificação</div>
        <h1 className="font-display text-3xl md:text-4xl font-extrabold tracking-tight mt-1">Ranking</h1>
        <p className="text-slate-600 mt-2 text-sm">Pontos por cursos concluídos, avaliações aprovadas e ciência de procedimentos.</p>
      </header>
      <Card><CardContent className="p-0">
        <table className="w-full text-sm">
          <thead className="bg-slate-50 text-left text-xs uppercase tracking-wide text-slate-500">
            <tr>
              <th className="px-4 py-3">Posição</th>
              <th className="px-4 py-3">Colaborador</th>
              <th className="px-4 py-3">Nível</th>
              <th className="px-4 py-3 text-right">Pontos</th>
            </tr>
          </thead>
          <tbody>
            {items.map((u, i) => {
              const t = tierFor(u.points || 0);
              return (
                <tr key={u.id} className="border-t border-[var(--unigr-border)]">
                  <td className="px-4 py-3 w-16">{ICON(i)}</td>
                  <td className="px-4 py-3">
                    <div className="font-medium">{u.name}</div>
                    <div className="text-xs text-slate-500">{u.email}</div>
                  </td>
                  <td className="px-4 py-3"><span className={"px-2 py-1 rounded text-xs " + t.color}>{t.label}</span></td>
                  <td className="px-4 py-3 text-right font-mono font-semibold">{u.points || 0}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </CardContent></Card>
    </div>
  );
}
